import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Link } from 'react-router-dom';

function Button({
    className = '',
    children,
    to,
    href,
    title,
    onClick,
    style,
    ariaLabel,
    disabled,
    itemProp,
    route,
}) {
    if (route?.startsWith('https://')) {
        return (
            <a
                title={title}
                className={className}
                href={route}
                rel="noopener noreferrer"
                target="_blank"
                onClick={onClick}
                style={style}
                aria-label={ariaLabel}
                itemProp={itemProp}
            >
                {children}
            </a>
        );
    }

    if (to) {
        return (
            <Link
                title={title}
                to={to}
                onClick={onClick}
                style={style}
                aria-label={ariaLabel}
                itemProp={itemProp}
                className={`${className} `}
            >
                {children}
            </Link>
        );
    }

    if (href) {
        return (
            <a
                title={title}
                className={className}
                href={href}
                rel="noopener noreferrer"
                target="_blank"
                onClick={onClick}
                style={style}
                aria-label={ariaLabel}
                itemProp={itemProp}
            >
                {children}
            </a>
        );
    }

    return (
        <button
            title={title}
            className={className}
            onClick={onClick}
            style={style}
            type="button"
            aria-label={ariaLabel}
            disabled={disabled}
            itemProp={itemProp}
        >
            {children}
        </button>
    );
}

Button.propTypes = exact({
    className: PropTypes.string,
    children: PropTypes.node,
    to: PropTypes.string,
    href: PropTypes.string,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    style: PropTypes.object,
    ariaLabel: PropTypes.string,
    disabled: PropTypes.bool,
    itemProp: PropTypes.string,
    route: PropTypes.string,
});

export default Button;
